import React from "react";

import PlanItem from "./PlanItem";
import ResourceItem from "./ResourceItem";

import styles from "../../../styles/sass/searchresult.module.scss";

const ResourceContainer = (props = {}) => {
  const { resources = [], filter, onBookNow } = props;
  return (
    <div className={styles["resource-item"]}>
      {filter && resources?.length === 0 ? (
        <div className={styles["no-result"]}>
          <h2>
            Unfortunately, no resources are available. Click the above{" "}
            <i>Modify Search</i> Button.
          </h2>
          {/* <p>Try searching with other inputs that meet your expectations</p> */}
          <img alt="not found" src="/assets/images/no_data.svg"></img>
        </div>
      ) : (
        <p>You are viewing {resources?.length} Result based on your input</p>
      )}

      {resources?.map((resource, index) => (
        <ResourceItem
          key={index}
          resource={resource}
          filter={filter}
          onBookNow={onBookNow}
        />
      ))}

      <div className={styles["horizontal-rule"]}></div>
      <div className={styles["plan-container"]}>
        {resources.length > 0 &&
          !!resources?.find((resource) => resource?.plan?.length > 0) && (
            <p>Recommended Plans</p>
          )}

        <div className={styles["plans"]}>
          {resources.map((resource, index) => (
            <PlanItem
              key={index}
              resource={resource}
              filter={filter}
              onBookNow={onBookNow}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ResourceContainer;
